module.exports = __webpack_public_path__ + "static/img/card-logo.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/card-logo.png
// module id = 163
// module chunks = 0